module.exports = __webpack_public_path__ + "media/เป็นล้านเลยเหรอพี่.9db89792.mp3";